import type { IRentableGroupCalculatorValues } from "../rentableGroupCalculatorContainer";

const calculateTotalIncome = (
  income: IRentableGroupCalculatorValues["income"]
) =>
  (income.me || 0) +
  income.people.reduce((acc, curr) => acc + (curr.income || 0), 0);

export default calculateTotalIncome;
